// import React from "react";

// const Form = () => {
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const form = e.target;
//     if (form.checkValidity()) {
//       window.location.href = "https://sportsfan.co.nz/";
//     }
//   };

//   return (
//     <div className="containerForm">
//       <form id="promoForm" onSubmit={handleSubmit}>
//         <h2>Join SportsFan!</h2>

//         <label htmlFor="nameForm">First Name *</label>
//         <input type="text" id="nameForm" name="nameForm" required />

//         <label htmlFor="lastnameForm">Last Name *</label>
//         <input type="text" id="lastnameForm" name="lastnameForm" required />

//         <label htmlFor="sexForm">Sex *</label>
//         <select id="sexForm" name="sexForm" required>
//           <option value="">Select...</option>
//           <option value="female">Female</option>
//           <option value="male">Male</option>
//           <option value="other">Other</option>
//         </select>

//         <label htmlFor="ageForm">Age Range *</label>
//         <select id="ageForm" name="ageForm" required>
//           <option value="">Select...</option>
//           <option value="18-25">18–25</option>
//           <option value="26-35">26–35</option>
//           <option value="36-45">36–45</option>
//           <option value="46+">46+</option>
//         </select>

//         <label htmlFor="emailForm">Email *</label>
//         <input type="email" id="emailForm" name="emailForm" required />

//         <div className="checkboxForm">
//           <input type="checkbox" id="agreeForm" name="agreeForm" required />
//           <label htmlFor="agreeForm">
//             I agree to receive news, promotions, and special offers from SportsFan.
//           </label>
//         </div>

//         <button type="submit" id="sendForm">
//           Send
//         </button>
//       </form>

//       {/* <style jsx>{`
//         .containerForm {
//           font-family: Arial, sans-serif;
//           background: #fff;
//           padding: 20px 30px;
//           border-radius: 10px;
//           box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
//           width: 320px;
//           margin: 50px auto;
//         }
//         label {
//           display: block;
//           margin-top: 12px;
//           font-weight: bold;
//         }
//         input,
//         select {
//           width: 100%;
//           padding: 8px;
//           margin-top: 5px;
//           border: 1px solid #ccc;
//           border-radius: 5px;
//         }
//         .checkboxForm {
//           display: flex;
//           align-items: flex-start;
//           margin-top: 15px;
//         }
//         .checkboxForm input {
//           margin-right: 8px;
//           margin-top: 3px;
//         }
//         button {
//           width: 100%;
//           padding: 10px;
//           margin-top: 20px;
//           background: #0077cc;
//           color: white;
//           border: none;
//           border-radius: 5px;
//           font-size: 16px;
//           cursor: pointer;
//         }
//         button:hover {
//           background: #005fa3;
//         }
//       `}</style> */}
//     </div>
//   );
// };

// export default Form;



import React from "react";

const Form = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    if (form.checkValidity()) {
      const data = {
        "First Name": form.nameForm.value,
        "Last Name": form.lastnameForm.value,
        "Sex": form.sexForm.value,
        "Age Range": form.ageForm.value,
        "Email": form.emailForm.value,
        "Agree": form.agreeForm.checked ? "Yes" : "No",
      };

      // POST a Google Sheet usando SheetDB
      fetch("https://sheetdb.io/api/v1/liegf4rqubtqt", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then(() => {
          alert("Thank you! Enjoy the best prices on sportswear at sportfan.co.nz");
          window.location.href = "https://sportsfan.co.nz/";
        })
        .catch((err) => {
          console.error(err);
          alert("There was an error submitting the form.");
        });
    }
  };

  return (
    <div className="containerForm">
      <form id="promoForm" onSubmit={handleSubmit}>
        <h2>Join SportsFan!</h2>

        <label htmlFor="nameForm">First Name *</label>
        <input type="text" id="nameForm" name="nameForm" required />

        <label htmlFor="lastnameForm">Last Name *</label>
        <input type="text" id="lastnameForm" name="lastnameForm" required />

        <label htmlFor="sexForm">Sex *</label>
        <select id="sexForm" name="sexForm" required>
          <option value="">Select...</option>
          <option value="female">Female</option>
          <option value="male">Male</option>
          <option value="other">Other</option>
        </select>

        <label htmlFor="ageForm">Age Range *</label>
        <select id="ageForm" name="ageForm" required>
          <option value="">Select...</option>
          <option value="18-25">18–25</option>
          <option value="26-35">26–35</option>
          <option value="36-45">36–45</option>
          <option value="46-65">46-56</option>
           <option value="57+">57+</option>
        </select>

        <label htmlFor="emailForm">Email *</label>
        <input type="email" id="emailForm" name="emailForm" required />

        <div className="checkboxForm">
          <input type="checkbox" id="agreeForm" name="agreeForm" required />
          <label htmlFor="agreeForm">
            I agree to receive news, promotions, and special offers from SportsFan.
          </label>
        </div>

        <button type="submit" id="sendForm">
          Send
        </button>
      </form>

      <style jsx>{`
        .containerForm {
          font-family: Arial, sans-serif;
          background: #fff;
          padding: 20px 30px;
          border-radius: 10px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          width: 320px;
          margin: 50px auto;
        }
        label {
          display: block;
          margin-top: 12px;
          font-weight: bold;
        }
        input,
        select {
          width: 100%;
          padding: 8px;
          margin-top: 5px;
          border: 1px solid #ccc;
          border-radius: 5px;
        }
        .checkboxForm {
          display: flex;
          align-items: flex-start;
          margin-top: 15px;
        }
        .checkboxForm input {
          margin-right: 8px;
          margin-top: 3px;
        }
        button {
          width: 100%;
          padding: 10px;
          margin-top: 20px;
          background: #0077cc;
          color: white;
          border: none;
          border-radius: 5px;
          font-size: 16px;
          cursor: pointer;
        }
        button:hover {
          background: #005fa3;
        }
      `}</style>
    </div>
  );
};

export default Form;
